import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import that from "../that.js";
export default function (initialize) {
  var _ref;

  var stale = false;
  var value;
  var resolve;
  var dispose = initialize(change);

  if (dispose != null && typeof dispose !== "function") {
    throw new Error(typeof dispose.then === "function" ? "async initializers are not supported" : "initializer returned something, but not a dispose function");
  }

  function change(x) {
    if (resolve) resolve(x), resolve = null;else stale = true;
    return value = x;
  }

  function next() {
    return {
      done: false,
      value: stale ? (stale = false, Promise.resolve(value)) : new Promise(function (_) {
        return resolve = _;
      })
    };
  }

  return _ref = {}, _defineProperty(_ref, Symbol.iterator, that), _defineProperty(_ref, "throw", function _throw() {
    return {
      done: true
    };
  }), _defineProperty(_ref, "return", function _return() {
    return dispose != null && dispose(), {
      done: true
    };
  }), _defineProperty(_ref, "next", next), _ref;
}